import { render, staticRenderFns } from "./SAASAMap.vue?vue&type=template&id=56decb26"
import script from "./SAASAMap.vue?vue&type=script&lang=js"
export * from "./SAASAMap.vue?vue&type=script&lang=js"
import style0 from "./SAASAMap.vue?vue&type=style&index=0&id=56decb26&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports